import L from 'mapbox.js';

// NOTE: Access token from Jim Wang
export const MAP_BOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiY29ydmEtYWkiLCJhIjoiY2tzeXg1Ym84Mm53NjJvbnZvZ3JxajVwayJ9.3B6ubssBj1UCqN5o25X6pw';
L.mapbox.accessToken = MAP_BOX_ACCESS_TOKEN;
